// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3AoLW","itemTitle":"ClientEmergencyInfo_itemTitle__10H5q","itemText":"ClientEmergencyInfo_itemText__1SNMf"};